import React from "react";

import { IoIosCafe } from "react-icons/io";

function Singular(data) {


  return (
    <div className="container cart">
      <div className="card-title center">
        <h2>
          <IoIosCafe /> {data.data["name"]}
        </h2>
      </div>
      <div className="card-title center">
        <h3>Fiyat : {data.data.price}₺</h3>
      </div>
    </div>
  );
}

export default Singular;
